export function isIn<T>(value: T, ...array: T[]): boolean {
    return array.includes(value)
}